import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SubscriptionService } from './subscription.service';
import { AuthService } from './auth.service';
import { SharedService } from './shared.service';
import { PermissionsState } from 'src/app/stores/access-control/access-control.reducers';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { PaywallPopupComponent } from '../components/paywall-popup/paywall-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
   providedIn: 'root',
})
export class AccessControlService {
   constructor(
      private toaster: ToastrService,
      private auth: AuthService,
      private sharedService: SharedService,
      private router: Router,
      private permissionStore: Store<{ permissions: PermissionsState }>,
      private modalService: NgbModal
   ) {
      this.permissionStore
         .select(({ permissions }) => permissions)
         .subscribe((permissions) => {
            this.isPermissionFirstLoaded = permissions.isLoaded;
            this.isPermissionLoading = permissions.loading;
         });
   }

   private isPermissionFirstLoaded: boolean = false;
   private isPermissionLoading: boolean = false;
   // private isCheckInProcess: boolean = false;

   async accessDenied() {
      this.modalService.dismissAll();
      if (!this.auth.isLoggedIn()) {
         this.auth.openAuthPopup(null, null, 'signUp', 'waitlist');
         return;
      }
      this.router.navigate(['/pricing']);
   }

   until(conditionFunction: () => any) {
      const poll = (resolve: any) => {
         if (conditionFunction()) resolve();
         else setTimeout(() => poll(resolve), 400);
      };
      return new Promise(poll);
   }
}
